export const API = "api_key";
export const API_KEY = "67b711ffb45eec9a16f207b155e465ef";
export const BASE_URL = "https://api.themoviedb.org/3";
const IMAGE_URL = "https://image.tmdb.org/t/p";
export const IMAGE_URL_W185 = `${IMAGE_URL}/w185`;
export const IMAGE_URL_W500 = `${IMAGE_URL}/w500`;
export const IMAGE_URL_ORIGINAL = `${IMAGE_URL}/original`;
